var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "day",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8184",
    "data-name": "Rectangle 8184",
    width: 20,
    height: 20,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_40753",
    "data-name": "Path 40753",
    d: "M8.5,6.455A2.045,2.045,0,1,1,6.455,8.5,2.051,2.051,0,0,1,8.5,6.455m0-1.364A3.409,3.409,0,1,0,11.909,8.5,3.41,3.41,0,0,0,8.5,5.091ZM1.682,9.182H3.045a.682.682,0,0,0,0-1.364H1.682a.682.682,0,1,0,0,1.364Zm12.273,0h1.364a.682.682,0,0,0,0-1.364H13.955a.682.682,0,0,0,0,1.364Zm-6.136-7.5V3.045a.682.682,0,0,0,1.364,0V1.682a.682.682,0,1,0-1.364,0Zm0,12.273v1.364a.682.682,0,0,0,1.364,0V13.955a.682.682,0,0,0-1.364,0ZM4.4,3.441a.68.68,0,0,0-.961.961l.723.723a.68.68,0,0,0,.961-.961Zm8.434,8.434a.68.68,0,0,0-.961.961l.723.723a.68.68,0,0,0,.961-.961ZM13.559,4.4a.68.68,0,0,0-.961-.961l-.723.723a.68.68,0,0,0,.961.961ZM5.125,12.836a.68.68,0,0,0-.961-.961l-.723.723a.68.68,0,0,0,.961.961Z",
    transform: "translate(2 2)",
    fill: "#898989"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDay);
export default __webpack_public_path__ + "static/media/day.ea5a9f1e9770cc4b8314ff00fd2eb60b.svg";
export { ForwardRef as ReactComponent };